import { render, staticRenderFns } from "./PhotoReportColorModal.vue?vue&type=template&id=4dddfc8e&scoped=true&"
import script from "./PhotoReportColorModal.vue?vue&type=script&lang=js&"
export * from "./PhotoReportColorModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoReportColorModal.vue?vue&type=style&index=0&id=4dddfc8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddfc8e",
  null
  
)

export default component.exports